import { memo, useEffect, useRef, useState } from 'react';
import styles from './InputModal..module.scss';
import placeApi from '~/api/placeApi';
import { isSuccess } from '~/utils/api';
import { toast } from 'react-toastify';
import { genUniqueKey } from '~/utils/common';
import { actions, useStore } from '~/store';
import { insertPlace } from '~/store/actions';

function InputModal({ onCancel, onSave }) {
    const [state, dispatch] = useStore();
    const [tripId] = useState(localStorage.getItem('tripId'));
    const [value, setValue] = useState('');
    const ref = useRef(null);

    const handleCancel = () => {
        if (onCancel) onCancel();
    };

    const handleSave = () => {
        // check rỗng
        if (value === '') {
            toast.warn('Chưa nhập mà');
            return;
        }

        // check trùng tên với địa điểm khác
        const duplicatedName = state.places.find(
            (place) => place.name === value,
        );
        if (duplicatedName) {
            toast.warn('Trùng tên với địa điểm khác rồi');
            return;
        }

        const id = genUniqueKey();
        dispatch(insertPlace({ id, name: value, tripId }));

        if (onSave) onSave({ id, name: value });
        dispatch(actions.setLoading2({ loading2: true }));
        placeApi
            .insert({ id, name: value, tripId })
            .then((res) => {
                // console.log('res', res);
                if (isSuccess(res)) {
                    toast.success('Thêm địa điểm thành công');
                } else {
                    toast.error(res.data);
                }
                dispatch(actions.setLoading2({ loading2: false }));
            })
            .catch((error) => {
                console.log(error);
                toast.error(JSON.stringify(error));
                dispatch(actions.setLoading2({ loading2: false }));
            });
    };

    const handleOnChange = (e) => {
        setValue(e.target.value);
    };

    useEffect(() => {
        ref.current.focus();
    }, []);
    return (
        <div className={styles.modal}>
            <div className={styles.wrapper}>
                <div className={styles.label}>Nhập địa điểm mới</div>
                <input
                    ref={ref}
                    type="text"
                    value={value}
                    onChange={handleOnChange}
                />
                <div className={styles.action}>
                    <button className={styles.cancel} onClick={handleCancel}>
                        Hủy
                    </button>
                    <button className={styles.save} onClick={handleSave}>
                        Lưu
                    </button>
                </div>
            </div>
        </div>
    );
}

export default memo(InputModal);
